import React from "react";

/**
 * TechnoDivider: HUD Circuit Grid divider with straight flat central line
 * for seamless 50/50 logo docking.
 *
 * Flanks: Cyber telemetry notches, matrix dots, glowing cyan neon rim.
 * Center: Perfectly straight horizontal edge at y=18 where the <DB> logo
 * sits exactly half in the 3D dark scene and half in the white section.
 */
const TechnoDivider = ({ className = "" }) => {
  return (
    <div className={`techno-divider-wrapper ${className}`}>
      <div className="techno-divider techno-divider-hud" aria-hidden="true">
        {/* Desktop Version (>= 769px) */}
        <svg
          className="techno-divider-svg techno-divider-svg-desktop"
          viewBox="0 0 1440 50"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="hudNeonGlowFixed" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#00f2fe" stopOpacity="0.2" />
              <stop offset="20%" stopColor="#00f2fe" stopOpacity="0.9" />
              <stop offset="50%" stopColor="#00f2fe" stopOpacity="1" />
              <stop offset="80%" stopColor="#00f2fe" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#00f2fe" stopOpacity="0.2" />
            </linearGradient>
          </defs>

          {/* Glowing cyber neon rim line */}
          <path
            className="techno-rim-line"
            d="M0,18 L180,18 L200,8 L520,8 L535,18 L905,18 L920,8 L1240,8 L1260,18 L1440,18"
            fill="none"
            stroke="url(#hudNeonGlowFixed)"
            strokeWidth="2.5"
          />

          {/* Solid clean white body without inner holes/notches */}
          <path
            d="M0,18 L180,18 L200,8 L520,8 L535,18 L905,18 L920,8 L1240,8 L1260,18 L1440,18 L1440,50 L0,50 Z"
            fill="#ffffff"
          />
        </svg>

        {/* Mobile Version (<= 768px): Pulito, geometrico solido, senza intagli interni */}
        <svg
          className="techno-divider-svg techno-divider-svg-mobile"
          viewBox="0 0 420 50"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="hudNeonGlowMobile" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#00f2fe" stopOpacity="0.25" />
              <stop offset="20%" stopColor="#00f2fe" stopOpacity="0.9" />
              <stop offset="50%" stopColor="#00f2fe" stopOpacity="1" />
              <stop offset="80%" stopColor="#00f2fe" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#00f2fe" stopOpacity="0.25" />
            </linearGradient>
          </defs>

          {/* Cyber neon rim */}
          <path
            className="techno-rim-line"
            d="M0,18 L20,18 L35,8 L120,8 L135,18 L285,18 L300,8 L385,8 L400,18 L420,18"
            fill="none"
            stroke="url(#hudNeonGlowMobile)"
            strokeWidth="2.5"
          />

          {/* Solid white body per mobile senza buchi */}
          <path
            d="M0,18 L20,18 L35,8 L120,8 L135,18 L285,18 L300,8 L385,8 L400,18 L420,18 L420,50 L0,50 Z"
            fill="#ffffff"
          />
        </svg>
      </div>
    </div>
  );
};

export default TechnoDivider;
